var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMug(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 280,
    viewBox: "0 0 350 280",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 350,
    height: 280,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.8 91C295.212 91 299.6 95.3876 299.6 100.8C299.6 106.212 295.212 110.6 289.8 110.6H233.8C239.212 110.6 243.6 114.988 243.6 120.4C243.6 125.812 239.212 130.2 233.8 130.2H264.6C270.012 130.2 274.4 134.588 274.4 140C274.4 145.412 270.012 149.8 264.6 149.8H250.356C243.532 149.8 238 154.188 238 159.6C238 163.208 240.8 166.475 246.4 169.4C251.812 169.4 256.2 173.788 256.2 179.2C256.2 184.612 251.812 189 246.4 189H130.2C124.787 189 120.4 184.612 120.4 179.2C120.4 173.788 124.787 169.4 130.2 169.4H75.5998C70.1874 169.4 65.7998 165.012 65.7998 159.6C65.7998 154.188 70.1874 149.8 75.5998 149.8H131.6C137.012 149.8 141.4 145.412 141.4 140C141.4 134.588 137.012 130.2 131.6 130.2H96.5998C91.1874 130.2 86.7998 125.812 86.7998 120.4C86.7998 114.988 91.1874 110.6 96.5998 110.6H152.6C147.187 110.6 142.8 106.212 142.8 100.8C142.8 95.3876 147.187 91 152.6 91H289.8ZM289.8 130.2C295.212 130.2 299.6 134.588 299.6 140C299.6 145.412 295.212 149.8 289.8 149.8C284.387 149.8 280 145.412 280 140C280 134.588 284.387 130.2 289.8 130.2Z",
    fill: "#F6F7F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.919 186.47L142.005 186.397V215.795C142.005 216.461 142.547 217 143.215 217H215.791C216.459 217 217 216.461 217 215.795V115.017C217 112.578 215.014 110.6 212.565 110.6H146.44C143.991 110.6 142.005 112.578 142.005 115.017V135.972L139.919 135.9C139.674 135.891 139.429 135.887 139.183 135.887C126.533 135.887 116.2 147.174 116.2 161.185C116.2 175.195 126.533 186.482 139.183 186.482C139.429 186.482 139.674 186.478 139.919 186.47ZM140.15 176.807C139.829 176.832 139.506 176.845 139.183 176.845C131.548 176.845 125.501 169.768 125.501 161.185C125.501 152.601 131.548 145.524 139.183 145.524C139.506 145.524 139.829 145.537 140.15 145.563L142.005 145.711V176.658L140.15 176.807Z",
    fill: "white",
    stroke: "#6D7078",
    strokeWidth: 3.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.8 119.254V144.9M205.8 152.854V159.495V152.854Z",
    stroke: "#C9CACF",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M93.979 205.8H103.6M253.579 205.8H257.6M225.4 205.8H246.999M112 205.8H136.436",
    stroke: "#6D7078",
    strokeWidth: 3.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M179.2 49C175.467 54.899 173.6 60.0323 173.6 64.4C173.6 72.1786 180.115 75.6622 180.115 84.0882C180.115 88.3647 177.944 92.611 173.6 96.827",
    stroke: "#C9CACF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M162.4 64.3999C161.178 72.1177 166.6 73.545 166.6 80.4643C166.6 83.9762 165.2 87.488 162.4 90.9999",
    stroke: "#C9CACF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.714 60.8638C186.864 65.6506 187.903 68.5684 188.714 70.2857C190.446 73.9566 193.2 77.1254 193.2 80.8609C193.2 85.1995 191.705 89.3749 188.714 93.3871",
    stroke: "#C9CACF",
    strokeWidth: 3.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M147 117.6C147 116.827 147.627 116.2 148.4 116.2L175 116.2V212.8H148.4C147.627 212.8 147 212.173 147 211.4V117.6Z",
    fill: "#F6F7F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMug);
export default __webpack_public_path__ + "static/media/mug.ebfce2755dd6ed9551cccc0fd67a9e62.svg";
export { ForwardRef as ReactComponent };